import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import LogoutButton from "../../components/icon-buttons/LogoutButton";
import AICommandBox from "../../js/ai/AICommandBox";
import auth, { featureEnabled, getMyImageUrl, setRem } from "../../js/auth";
import EatWithMeText from "../../components/EatWIthMeText";
import MenuItemHeader from "../../components/MenuItemHeader";
import ChangeLanguage from "../../components/icon-buttons/ChangeLanguage";
import UserImageButton from "../../components/icon-buttons/UserImageButton";
import moment from "moment";
import { withRouter } from "react-router-dom";
import MyDateRangePicker from "../../components/MyDateRangePicker";
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import IncomingStocksContainer from './IncomingStocksContainer';
import FileUploadDownload from './FileUploadDownload';
import { I18n } from "react-redux-i18n";
import SubmenuHeader from "../../components/menus/SubMenuHeader";


class IncomingStocksNew extends Component {
    state = {
        startDate: moment(Number(localStorage.admin_stocklist_start)),
        endDate: moment(Number(localStorage.admin_stocklist_end)),
        initialized: false,
        supplierSelected: null,
        entries: [],
        statusFilter: 'all'
    };
    handleStatusFilterChange = (e) => {
        this.setState({ statusFilter: e.target.value });
    }

    static getDerivedStateFromProps(props, state) {
        return state;
    }

    componentDidMount() {
        const { myStatus } = this.props;

        if (myStatus && myStatus.restaurant_id) {
            this.setState({ initialized: true });
        }

        auth.minfontsize = 10;
        setRem();
    }

    componentDidUpdate() {
        const { myStatus } = this.props;

        if (myStatus && myStatus.restaurant_id && !this.state.initialized) {
            this.setState({ initialized: true });
        }
    }

    stocksContainerRef = React.createRef();

    render() {
        const { myStatus, online_szamla } = this.props;
        if (myStatus && myStatus.restaurant_id) {
            return (
                <div id="IncomingStocksNew" className="stock-actions" style={{ display: "flex", flexFlow: "column", flexGrow: 1, height: "100%" }}>
                    <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.incomingStocks")} />

                    {/* Date Range Picker and Status Filter */}
                    <div style={{
                        display: "flex",
                        flexFlow: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        flexGrow: 0,
                        flexShrink: 0,
                        fontSize: "20px",
                        gap: "1rem"
                    }}>
                        <MyDateRangePicker
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onApply={this.dateRangeChanged}
                        />
                        {online_szamla !== false && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
                                <label htmlFor="statusFilter" style={{ fontWeight: 500 }}>{I18n.t('admin_local.status_filter_placeholder', 'Status')}:</label>
                                <select
                                    id="statusFilter"
                                    value={this.state.statusFilter}
                                    onChange={this.handleStatusFilterChange}
                                    style={{ padding: '0.15em 0.5em', fontSize: '1em', marginLeft: '0.5em', background: 'transparent' }}
                                >
                                    <option value="all">⬜ {I18n.t('admin_local.status_filter_all', 'All')}</option>
                                    <option value="draft">📝 {I18n.t('admin_local.status_draft', 'Draft')}</option>
                                    <option value="new">🆕 {I18n.t('admin_local.status_new', 'New')}</option>
                                    <option value="linked">🔗 {I18n.t('admin_local.status_linked', 'Linked')}</option>
                                    <option value="ignored">🗑️ {I18n.t('admin_local.status_ignored', 'Ignored')}</option>
                                </select>
                            </div>
                        )}
                    </div>

                    {/* Main Content */}
                    <div style={{ flexGrow: 1, overflow: 'hidden' }}>
                        <IncomingStocksContainer
                            ref={this.stocksContainerRef}
                            dateRange={{
                                startDate: this.state.startDate,
                                endDate: this.state.endDate
                            }}
                            statusFilter={online_szamla !== false ? this.state.statusFilter : undefined}
                            {...this.props}
                            downloadLabel={I18n.t('admin_local.stocks.download')}
                            uploadLabel={I18n.t('admin_local.stocks.upload')}
                            printLabel={I18n.t('admin_local.stocks.print')}
                            addLabel={I18n.t('admin_local.stocks.add')}
                            editLabel={I18n.t('admin_local.stocks.edit')}
                            deleteLabel={I18n.t('admin_local.stocks.delete')}
                            onSupplierSelect={this.handleSupplierSelect}
                            online_szamla={online_szamla}
                        />
                    </div>

                    {!auth.isIncludedInFrame ? <AICommandBox /> : ""}
                </div>
            );
        } else return null;
    }

    dateRangeChanged = (event, values) => {
        // Update localStorage for persistence
        localStorage.admin_stocklist_start = values.startDate._d.getTime();
        localStorage.admin_stocklist_end = values.endDate._d.getTime();

        // Update state, which will update IncomingStocksContainer via props
        this.setState({
            startDate: values.startDate,
            endDate: values.endDate
        });
        // IncomingStocksContainer will reload based on new props
    }

    handleSupplierSelect = (supplier) => {
        this.setState({ supplierSelected: supplier });
        // Autopopulate entries if none exist yet
        if (!this.state.entries || this.state.entries.length === 0) {
            // Example: create a default entry for the selected supplier
            this.setState({
                entries: [{
                    supplier: supplier,
                    // Add other default fields as needed
                }]
            });
        }
    };

}
const mapStateToProps = (props, state) => {
    if (typeof localStorage.admin_stocklist_start === "undefined") {
        localStorage.admin_stocklist_start = new Date().getTime();
        localStorage.admin_stocklist_end = new Date().getTime();
    }
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            // Redux dropdowns
            suppliers: props.rootReducer.suppliers,
            stores: props.rootReducer.stores,
            vatCategories: props.rootReducer.vatCategories,
            quantityTypes: props.rootReducer.quantityTypes,
            menuItems: props.rootReducer.menuItems,
            products: props.rootReducer.menuCategories,
            online_szamla: !!featureEnabled('online_szamla'),
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(IncomingStocksNew));